/**
 * Created by emanuele on 29/01/2017.
 */
/* eslint-disable no-constant-condition */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react'
import {arrayToCombo} from '../Helpers'
import {client} from '../Client';

class PdcMultiCombo extends Component {
    constructor(props) {
        super(props);
        let fields = {pdc1: undefined, pdc2: undefined, pdc3: undefined }
        this.state = {
            idPdc: undefined,
            fields: fields,
            dropdownPdc1Loading: false,
            dropdownPdc1List: [],
            dropdownPdc2Loading: false,
            dropdownPdc2List: [],
            dropdownPdc3Loading: false,
            dropdownPdc3List: [],
        };
        this.onInputChange = this.onInputChange.bind(this);
        this.comboPdc1 = this.comboPdc1.bind(this);
        this.comboPdc2 = this.comboPdc2.bind(this);
        this.comboPdc3 = this.comboPdc3.bind(this);
        this.doOnChange = this.doOnChange.bind(this);
        this.loadPdc = this.loadPdc.bind(this);
    }

    componentWillReceiveProps(nextProps){
        let newId = ''+nextProps.idPdc;
        let oldId = ''+this.state.idPdc;
        if (newId !== oldId)
        {
            //console.log("On props change", nextProps.idPdc, this.state.idPdc)
            this.loadPdc(nextProps.idPdc, () => {
                this.comboPdc2(this.state.fields.pdc1, () => {
                    this.comboPdc3(this.state.fields.pdc2);
                });

            })
        }
    }

    componentDidMount(){
        this.comboPdc1();
    }

    doOnChange(value){
        if (this.props.onChange){
            this.props.onChange(null, {name: 'idPdc', value: value})
        }
    }

    comboPdc3(cod) {
        this.setState({ dropdownPdc3Loading: true });
        //console.log("comboPdc3.loadPianoDeiContiAllListLiv3", this.state.fields.pdc1, cod);
        client.loadPianoDeiContiAllListLiv3(this.state.fields.pdc1, cod).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    let items = [];
                    items = items.concat(data);
                    //console.log("comboPdc3 data", data);
                    this.setState({
                        dropdownPdc3Loading: false,
                        error: null,
                        dropdownPdc3List: arrayToCombo(items, "cod", "descrizione", "cod", false)
                    }, () => {
                        // Se l'elenco è composto da un singolo elemento le preseleziona
                        if (items.length === 1){
                            const fields = this.state.fields;
                            fields.pdc3 = items[0].cod;
                            this.setState({fields},
                                () => {
                                    this.doOnChange(fields.pdc3)
                                });
                        }
                    })
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }            else
            {
                response.json().then((errore) => {
                    let fieldErrorsText = []
                    let fieldErrors = {}
                    this.setState({
                        dropdownPdc3Loading: false,
                        fieldErrors: fieldErrors,
                        fieldErrorsText: fieldErrorsText,
                        errorTitle: '',
                        error: {title: errore.title, msg: errore.msg},
                        inError: true
                    });
                });
            }
        }).catch((error) => {
            let fieldErrorsText = []
            let fieldErrors = {}
            this.setState({
                dropdownPdc3Loading: false,
                fieldErrors: fieldErrors,
                fieldErrorsText: fieldErrorsText,
                errorTitle: '',
                error: {title: "Errore di rete imprevisto", msg: error.message},
                inError: true
            });
        });
    }

    comboPdc2(cod, cb) {
        this.setState({ dropdownPdc2Loading: true });
        client.loadPianoDeiContiAllListLiv2(cod).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    let items = [];
                    items = items.concat(data);
                    this.setState({
                        dropdownPdc2Loading: false,
                        error: null,
                        dropdownPdc2List: arrayToCombo(items, "cod", "descrizione", "cod", false)
                    }, cb)
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }            else
            {
                response.json().then((errore) => {
                    let fieldErrorsText = []
                    let fieldErrors = {}
                    this.setState({
                        dropdownPdc2Loading: false,
                        fieldErrors: fieldErrors,
                        fieldErrorsText: fieldErrorsText,
                        errorTitle: '',
                        error: {title: errore.title, msg: errore.msg},
                        inError: true
                    });
                });
            }
        }).catch((error) => {
            let fieldErrorsText = []
            let fieldErrors = {}
            this.setState({
                dropdownPdc2Loading: false,
                fieldErrors: fieldErrors,
                fieldErrorsText: fieldErrorsText,
                errorTitle: '',
                error: {title: "Errore di rete imprevisto", msg: error.message},
                inError: true
            });
        });
    }

    comboPdc1(){
        this.setState({ dropdownPdc1Loading: true });
        client.loadPianoDeiContiAllListLiv1().then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    let items = [];
                    items = items.concat(data);
                    this.setState({
                            dropdownPdc1Loading: false,
                        error: null,
                        dropdownPdc1List: arrayToCombo(items, "cod", "descrizione", "cod", false)
                    })
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }            else
            {
                response.json().then((errore) => {
                    let fieldErrorsText = []
                    let fieldErrors = {}
                    this.setState({
                        dropdownPdc1Loading: false,
                        fieldErrors: fieldErrors,
                        fieldErrorsText: fieldErrorsText,
                        errorTitle: '',
                        error: {title: errore.title, msg: errore.msg},
                        inError: true
                    });
                });
            }
        }).catch((error) => {
            let fieldErrorsText = []
            let fieldErrors = {}
            this.setState({
                dropdownPdc1Loading: false,
                fieldErrors: fieldErrors,
                fieldErrorsText: fieldErrorsText,
                errorTitle: '',
                error: {title: "Errore di rete imprevisto", msg: error.message},
                inError: true
            });
        });
    }

    loadPdc(idPdc, cb){
        //console.log("loadPCD:", idPdc);
        client.loadPianoDeiConti(idPdc).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    //console.log("loadPCD data:", data, data.idPdc, ''+data.idPdc);
                    this.setState({
                        idPdc: data.idPdc,
                        fields: {
                            pdc1: data.catProg,
                            pdc2: data.voxProg,
                            pdc3: data.idPdc,
                        },
                        error: null,
                    }, cb)
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }            else
            {
                response.json().then((errore) => {
                    let fieldErrorsText = []
                    let fieldErrors = {}
                    this.setState({
                        dropdownPdc1Loading: false,
                        fieldErrors: fieldErrors,
                        fieldErrorsText: fieldErrorsText,
                        errorTitle: '',
                        error: {title: errore.title, msg: errore.msg},
                        inError: true
                    });
                });
            }
        }).catch((error) => {
            let fieldErrorsText = []
            let fieldErrors = {}
            this.setState({
                dropdownPdc1Loading: false,
                fieldErrors: fieldErrors,
                fieldErrorsText: fieldErrorsText,
                errorTitle: '',
                error: {title: "Errore di rete imprevisto", msg: error.message},
                inError: true
            });
        });
    }

    onInputChange(a1, b1) {
        let name = b1.name;
        let value = b1.value;

        if (name !== undefined)
        {
            //console.log("onInputChange", name, value);
            const fields = this.state.fields;
            fields[name] = value;

            if (name === 'pdc1') {
                // Carica pdc2 e resetta pdc3
                fields["pdc2"] = undefined;
                fields["pdc3"] = undefined;
                this.setState({
                    fields,
                    dropdownPdc2Loading: false,
                    dropdownPdc2List: [],
                    dropdownPdc3Loading: false,
                    dropdownPdc3List: [],
                });
                this.comboPdc2(value);
            }
            else if (name === 'pdc2') {
                // Carica pdc3
                fields["pdc3"] = undefined;
                this.setState({
                    fields,
                    dropdownPdc3Loading: false,
                    dropdownPdc3List: [],
                });
                this.comboPdc3(value);
            }
            else if (name === 'pdc3'){
                // Caricati tutti e tre i valori. Seleziona l'idPdc giusto e notifica il cambio
                // di valore all'esterno.
                this.setState({
                    fields,
                    idPdc: value,
                }, () => {
                    this.doOnChange(fields.pdc3)
                });
            }
        }
    }

    render() {
        let lbl = null;
        if (this.props.label) {
            lbl = <label> {this.props.label} </label>
        }
        let classnameField = this.props.required ? 'required field' : 'field';

        return (
            <div className={classnameField}>
                {lbl}
                <div className="inline fields">
                    <Form.Field className="inline fields" width={6}>

                        <Form.Dropdown placeholder='Scegli una categoria' width={16} style={{width:"100%"}} name='pdc1' disabled={this.props.abilitato === false} loading={this.state.dropdownPdc1Loading} search selection options={this.state.dropdownPdc1List} value={this.state.fields.pdc1} onChange={this.onInputChange}/>
                    </Form.Field>
                    <Form.Field className="inline fields" width={6}>
                        <Form.Dropdown placeholder='Scegli una voce' width={16} style={{width:"100%"}} name='pdc2' disabled={this.props.abilitato === false && this.state.fields.pdc1 === undefined} loading={this.state.dropdownPdc2Loading} search selection options={this.state.dropdownPdc2List} value={this.state.fields.pdc2} onChange={this.onInputChange}/>
                    </Form.Field>
                    <Form.Field className="inline fields" width={6} style={{padding:0}}>
                        <Form.Dropdown placeholder='Scegli una sottocategoria' width={16} style={{width:"100%"}} name='pdc3' disabled={this.props.abilitato === false && this.state.fields.pdc2 === undefined} loading={this.state.dropdownPdc3Loading} search selection options={this.state.dropdownPdc3List} value={this.state.fields.pdc3} onChange={this.onInputChange}/>
                    </Form.Field>
                </div>
            </div>)
    }
}

PdcMultiCombo.PropTypes = {
    idPdc: PropTypes.number.isRequired,
    required: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    abilitato: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
};

PdcMultiCombo.defaultProps = {
    idPdc: undefined,
    abilitato: true,
    required: false,
    label: undefined,
};

export default PdcMultiCombo;



/** WEBPACK FOOTER **
 ** ./src/components/PdcMultiCombo.js
 **/